import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { withEnvGuard } from '@traton/devportal-env-kit-app';

import { rootRouteRef } from './routes';

export const techdocPlaygroundPlugin = createPlugin({
  id: 'techdoc-playground',
  routes: {
    root: rootRouteRef,
  },
});

export const TechdocplaygroundPage = techdocPlaygroundPlugin.provide(
  createRoutableExtension({
    name: 'TechdocplaygroundPage',
    component: () =>
      import('./ProjectExplorer').then(m =>
        withEnvGuard(m.ProjectExplorerPage, 'techdoc-playground'),
      ),
    mountPoint: rootRouteRef,
  }),
);
